export default __webpack_public_path__ + "2773af0c040ff0fb418be365947da81d.png";